/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerDto } from '../../models/banner-dto';
import { BannerUpdateDto } from '../../models/banner-update-dto';

export interface BannerAdminControllerUpdateV1$Params {
  id: string;
      body: BannerUpdateDto
}

export function bannerAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: BannerAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
  const rb = new RequestBuilder(rootUrl, bannerAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BannerDto>;
    })
  );
}

bannerAdminControllerUpdateV1.PATH = '/api/v1/banners/admin/{id}';
